module.exports = __webpack_public_path__ + "static/media/bakhra.631f0102.ogg";